import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { ProtectedRouteProps } from "@/types";
import { Loader2 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <Card className="w-[300px] shadow-lg">
          <CardContent className="flex flex-col items-center justify-center pt-6 pb-6">
            <div className="relative">
              <div className="absolute inset-0 rounded-full bg-blue-100 animate-pulse"></div>
              <Loader2 className="relative h-12 w-12 animate-spin text-blue-500" aria-hidden="true" />
            </div>
            <p className="mt-4 text-base font-medium text-gray-700">Loading your profile...</p>
            <p className="text-xs text-gray-500 mt-2">Please wait while we prepare your experience</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};